(() => {
  function init(root) {
    if(root.dataset.initialized) return;
    root.dataset.initialized='true';
    const radios=[...root.querySelectorAll('[data-contact-route]')];
    const panels=[...root.querySelectorAll('[data-contact-panel]')];
    function update() {
      const route=radios.find(r=>r.checked)?.value;
      panels.forEach(panel=>{panel.hidden=panel.dataset.contactPanel!==route;});
    }
    radios.forEach(r=>r.addEventListener('change',update));
    update();
  }
  const mount=()=>document.querySelectorAll('[data-neulo-contact]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
  document.addEventListener('shopify:section:load',mount);
})();
